import { SVG, Path } from "@wordpress/components";

export const SliderIcon = () => (
	<SVG xmlns="//www.w3.org/2000/svg" viewBox="0 0 100 100">
		<Path d="M98.2 17.4H87.6v-5.2c0-.9-.8-1.8-1.8-1.8H14.2c-.9 0-1.8.8-1.8 1.8v5.2H1.8c-.9 0-1.8.8-1.8 1.8v45.1c0 .9.8 1.8 1.8 1.8h10.6v5.2c0 .9.8 1.8 1.8 1.8h71.6c.9 0 1.8-.8 1.8-1.8v-5.2h10.6c.9 0 1.8-.8 1.8-1.8V19.2c0-.9-.7-1.8-1.8-1.8zM84 14.1v43.4L72.6 44.9c-2.1-2.3-6.1-2.3-8.2 0l-5.5 6L43.2 33c-1.2-1.3-2.7-2-4.5-2-1.7 0-3.4.7-4.5 2L16 53.9V14.1h68zM3.6 62.5V21h8.8v41.5H3.6zM16 69.4V59.3l20.9-24c.4-.5 1.1-.8 1.8-.8s1.4.3 1.8.8l16.9 19.5c.3.4.8.6 1.4.6.4 0 .9-.2 1.4-.6l6.8-7.5c.7-.8 2.2-.8 2.9 0L84 62.8v6.6H16zm80.4-6.9h-8.8V21h8.8v41.5z" />
		<Path d="M69.2 36.4c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5-7.5 3.4-7.5 7.5 3.4 7.5 7.5 7.5zm0-11.4c2.1 0 3.9 1.8 3.9 3.9s-1.8 3.9-3.9 3.9-3.9-1.8-3.9-3.9 1.8-3.9 3.9-3.9z" />
		<circle cx="26.9" cy="82.6" r="4" />
		<circle cx="42.3" cy="82.6" r="4" />
		<circle cx="57.7" cy="82.6" r="4" />
		<circle cx="73.1" cy="82.6" r="4" />
	</SVG>
);
export const ProductTemplateIcon = () => (	
	<SVG xmlns="//www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M6 4h12c1.1046 0 2 .89543 2 2v12c0 1.1046-.8954 2-2 2H6c-1.10457 0-2-.8954-2-2V6c0-1.10457.89543-2 2-2Zm12 1.5H6c-.27614 0-.5.22386-.5.5v3h13V6c0-.27614-.2239-.5-.5-.5Zm.5 5H10v8h8c.2761 0 .5-.2239.5-.5v-7.5Zm-10 0h-3V18c0 .2761.22386.5.5.5h2.5v-8Z" />
  	</SVG>
);
export const FilterIcon = () => (	
	<SVG xmlns="//www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M8 6.9c-.4-1.5-1.7-2.6-3.3-2.6S1.8 5.4 1.4 6.9H0v1.7h1.4c.2.6.5 1.1.9 1.6.3.3.7.6 1.1.7.4.2.9.3 1.3.3s.9-.2 1.3-.3c.4-.2.8-.4 1.1-.7.4-.4.7-1 .9-1.6h16V6.9H8zm-3.3 3.2c-1 0-1.9-.7-2.3-1.6-.1-.2-.1-.5-.1-.8s.1-.6.2-.9c.3-.9 1.2-1.6 2.3-1.6s1.9.7 2.3 1.6c-.1.3 0 .6 0 .9s-.1.6-.2.9c-.3.9-1.2 1.5-2.2 1.5zm17.9 5.3c-.4-1.5-1.7-2.6-3.3-2.6S16.4 14 16 15.4H0v1.7h16c.4 1.5 1.7 2.6 3.3 2.6s2.9-1.1 3.3-2.6H24v-1.7h-1.4zm-3.3 3.3c-1 0-1.9-.7-2.3-1.6-.1-.3-.2-.6-.2-.9s.1-.6.2-.9c.3-.9 1.2-1.6 2.3-1.6s1.9.7 2.3 1.6c.1.3.2.6.2.9s-.1.6-.2.9c-.4 1-1.2 1.6-2.3 1.6z" />
	</SVG>
);
export const SortIcon = () => (	
	<SVG xmlns="//www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M0 5.1h24v1.7H0zm0 6h16v1.7H0zm0 6h8v1.7H0z"/>
	</SVG>
);
export const PaginationIcon = () => (	
	<SVG xmlns="//www.w3.org/2000/svg" viewBox="0 0 24 24">
		<g fill="#6b6b6b">
			<path fillRule="evenodd" d="m1282.3 2195.6-6-4.7v9.4z" clipRule="evenodd"/>
			<path stroke="#6b6b6b" strokeMiterlimit="10" d="M1276.3 2195.6h-13"/>
		</g>
		<Path d="m24 12-7.6-6v5.5H0v1h16.4V18z"/>
	</SVG>
);